import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { isLoading } from 'flux-entities'

import { INewPlan } from '../../../../types/plan'
import { createPlan } from '../../../../store/plans/actions'
import { Create } from './Create'
import { ICreateDispatchProps, ICreateStateProps } from './types'
import { fetchDrugs } from '../../../../store/drugs/actions'
import { IState } from '../../../../store/types'

const mapStateToProps = (state: IState): ICreateStateProps => {
  return {
    drugs: state.drugs,
    plansLoading: isLoading(state.plans)
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): ICreateDispatchProps => {
  return {
    fetchDrugs: () => {
      return dispatch(fetchDrugs())
    },
    createPlan: (plan: INewPlan) => {
      return dispatch(createPlan(plan))
    }
  }
}

const CreateContainer = connect(mapStateToProps, mapDispatchToProps)(Create)

export {
  CreateContainer
}
